import type { ReactElement } from 'react';

export default function SidebarNewTag(): ReactElement {
  return (
    <span className="vtwo:flex vtwo:h-4 vtwo:shrink-0 vtwo:items-center vtwo:rounded-full vtwo:bg-linear-to-r vtwo:from-[#4db181] vtwo:to-[#3f7284] vtwo:px-1.5 vtwo:text-[10px] vtwo:font-semibold vtwo:leading-none vtwo:text-white">
      New
    </span>
  );
}
